import { ref, watch } from 'vue';

const isDarkMode = ref(true); // Default to Dark Mode

export function useTheme() {
    const initTheme = () => {
        const savedTheme = localStorage.getItem('theme');
        // If not explicitly set to light, stay in dark
        isDarkMode.value = savedTheme !== 'light';
        applyTheme();
    };

    const toggleTheme = () => {
        isDarkMode.value = !isDarkMode.value;
        localStorage.setItem('theme', isDarkMode.value ? 'dark' : 'light');
        applyTheme();
    };

    const applyTheme = () => {
        if (isDarkMode.value) {
            document.documentElement.setAttribute('data-theme', 'dark');
            document.documentElement.setAttribute('data-bs-theme', 'dark');
            document.body.classList.add('dark-theme');
            document.body.classList.remove('light-theme');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
            document.documentElement.setAttribute('data-bs-theme', 'light');
            document.body.classList.add('light-theme');
            document.body.classList.remove('dark-theme');
        }
    };

    return {
        isDarkMode,
        initTheme,
        toggleTheme
    };
}
